import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { WatchNowOfferFragmentDoc } from '../../../../pages/graphql/fragments/WatchNowOffer.fragment';
export type GetProviderTop10TitlesQueryVariables = Types.Exact<{
	streamingChartsFilter?: Types.InputMaybe<Types.StreamingChartsFilter>;
	first: Types.Scalars['Int']['input'];
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	backdropProfile?: Types.InputMaybe<Types.BackdropProfile>;
	profile?: Types.InputMaybe<Types.PosterProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	watchNowFilter: Types.WatchNowOfferFilter;
	offerFilter: Types.OfferFilter;
	platform?: Types.Platform;
}>;

export type GetProviderTop10TitlesQuery = {
	__typename?: 'Query';
	streamingCharts: {
		__typename?: 'StreamingChartsConnection';
		totalCount: number;
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
		edges?: Array<{
			__typename?: 'StreamingChartsTitlesEdge';
			streamingChartInfo?: {
				__typename?: 'StreamingChartInfo';
				rank: number;
				trend: Types.ModuleContentTitleTrend;
				trendDifference: number;
				daysInTop10: number;
				topRank: number;
			} | null;
			node:
				| {
						__typename?: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							isReleased: boolean;
							runtime?: number | null;
							originalReleaseYear?: number | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbVotes?: number | null;
								imdbScore?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							genres: Array<{ __typename?: 'Genre'; id: string; translation: string; shortName: string }>;
						};
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						offers: Array<{
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						}>;
						streamingCharts: {
							__typename?: 'StreamingChartsConnection';
							edges?: Array<{
								__typename?: 'StreamingChartsTitlesEdge';
								streamingChartInfo?: {
									__typename?: 'StreamingChartInfo';
									rank: number;
									trend: Types.ModuleContentTitleTrend;
									trendDifference: number;
								} | null;
							}> | null;
						};
				  }
				| {
						__typename?: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: {
							__typename?: 'SeasonContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							isReleased: boolean;
							runtime?: number | null;
							originalReleaseYear?: number | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbVotes?: number | null;
								imdbScore?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							genres: Array<{ __typename?: 'Genre'; id: string; translation: string; shortName: string }>;
						};
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						offers: Array<{
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						}>;
						streamingCharts: {
							__typename?: 'StreamingChartsConnection';
							edges?: Array<{
								__typename?: 'StreamingChartsTitlesEdge';
								streamingChartInfo?: {
									__typename?: 'StreamingChartInfo';
									rank: number;
									trend: Types.ModuleContentTitleTrend;
									trendDifference: number;
								} | null;
							}> | null;
						};
				  }
				| {
						__typename?: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number; progress: number };
						content: {
							__typename?: 'ShowContent';
							title: string;
							fullPath: string;
							posterUrl?: string | null;
							isReleased: boolean;
							runtime?: number | null;
							originalReleaseYear?: number | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: {
								__typename?: 'Scoring';
								imdbVotes?: number | null;
								imdbScore?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							genres: Array<{ __typename?: 'Genre'; id: string; translation: string; shortName: string }>;
						};
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						offers: Array<{
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						}>;
						streamingCharts: {
							__typename?: 'StreamingChartsConnection';
							edges?: Array<{
								__typename?: 'StreamingChartsTitlesEdge';
								streamingChartInfo?: {
									__typename?: 'StreamingChartInfo';
									rank: number;
									trend: Types.ModuleContentTitleTrend;
									trendDifference: number;
								} | null;
							}> | null;
						};
				  };
		}> | null;
	};
};

export const GetProviderTop10TitlesDocument = gql`
	query GetProviderTop10Titles(
		$streamingChartsFilter: StreamingChartsFilter
		$first: Int!
		$after: String
		$country: Country!
		$language: Language!
		$backdropProfile: BackdropProfile
		$profile: PosterProfile
		$format: ImageFormat
		$watchNowFilter: WatchNowOfferFilter!
		$offerFilter: OfferFilter!
		$platform: Platform! = WEB
	) {
		streamingCharts(filter: $streamingChartsFilter, first: $first, after: $after, country: $country) {
			totalCount
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			edges {
				streamingChartInfo {
					rank
					trend
					trendDifference
					daysInTop10
					topRank
				}
				node {
					id
					objectId
					objectType
					content(country: $country, language: $language) {
						title
						fullPath
						scoring {
							imdbVotes
							imdbScore
							tmdbPopularity
							tmdbScore
						}
						posterUrl(profile: $profile, format: $format)
						... on MovieOrShowOrSeasonContent {
							backdrops(profile: $backdropProfile, format: $format) {
								backdropUrl
							}
						}
						isReleased
						scoring {
							imdbVotes
						}
						runtime
						originalReleaseYear
						genres {
							id
							translation(language: $language)
							shortName
						}
					}
					likelistEntry {
						createdAt
					}
					dislikelistEntry {
						createdAt
					}
					watchNowOffer(country: $country, platform: $platform, filter: $watchNowFilter) {
						...WatchNowOffer
					}
					offers(country: $country, platform: $platform, filter: $offerFilter) {
						...WatchNowOffer
					}
					... on Movie {
						seenlistEntry {
							createdAt
						}
					}
					... on Show {
						tvShowTrackingEntry {
							createdAt
						}
						seenState(country: $country) {
							seenEpisodeCount
							progress
						}
					}
					streamingCharts(country: $country, filter: $streamingChartsFilter, first: $first) {
						edges {
							streamingChartInfo {
								rank
								trend
								trendDifference
							}
						}
					}
				}
			}
		}
	}
	${WatchNowOfferFragmentDoc}
`;
